function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12H10H42",
  stroke: "#EB5757",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5 12C39.5 11.1716 38.8284 10.5 38 10.5C37.1716 10.5 36.5 11.1716 36.5 12H39.5ZM11.5 12C11.5 11.1716 10.8284 10.5 10 10.5C9.17157 10.5 8.5 11.1716 8.5 12H11.5ZM14.5 12C14.5 12.8284 15.1716 13.5 16 13.5C16.8284 13.5 17.5 12.8284 17.5 12H14.5ZM30.5 12C30.5 12.8284 31.1716 13.5 32 13.5C32.8284 13.5 33.5 12.8284 33.5 12H30.5ZM36.5 12V40H39.5V12H36.5ZM36.5 40C36.5 41.3807 35.3807 42.5 34 42.5V45.5C37.0376 45.5 39.5 43.0376 39.5 40H36.5ZM34 42.5H14V45.5H34V42.5ZM14 42.5C12.6193 42.5 11.5 41.3807 11.5 40H8.5C8.5 43.0376 10.9624 45.5 14 45.5V42.5ZM11.5 40V12H8.5V40H11.5ZM17.5 12V8H14.5V12H17.5ZM17.5 8C17.5 6.61929 18.6193 5.5 20 5.5V2.5C16.9624 2.5 14.5 4.96243 14.5 8H17.5ZM20 5.5H28V2.5H20V5.5ZM28 5.5C29.3807 5.5 30.5 6.61929 30.5 8H33.5C33.5 4.96243 31.0376 2.5 28 2.5V5.5ZM30.5 8V12H33.5V8H30.5Z",
  fill: "#EB5757"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 22V34",
  stroke: "#EB5757",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28 22V34",
  stroke: "#EB5757",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTrashLarge = function SvgTrashLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-large.9f3f3215.svg";
export { ForwardRef as ReactComponent };